export default {
    'name': '5',
    'width': '64',
    'height': '64',
    'viewBox': '0 0 64 64',
    'data': '<g clip-path=\'url(#clip0_127_3828)\'><path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M64 0H0V64H64V0ZM14 39.9333V20.6303L30.6727 11V30.303L14 39.9333ZM32.4546 53.0001L15.697 43.3698L32.3698 33.7395L49.0849 43.3698L32.4546 53.0001ZM50.7394 20.6303L34.0667 11V30.303L50.7394 39.9333V20.6303Z\' fill=\'white\'/></g><defs><clipPath id=\'clip0_127_3828\'><rect width=\'64\' height=\'64\' fill=\'white\'/></clipPath></defs>'
}
